import AutoSizer from 'react-virtualized-auto-sizer';
import { ListSizeProps, VariableSizeListProps } from './types';
import VariableSizeList from './VariableSizeList';

const AutoSizedVariableSizeList = <TItem, >( props: VariableSizeListProps<TItem> ) => (
	<AutoSizer className={props.className}>
		{( { width, height }: ListSizeProps ) => <VariableSizeList width={width} height={height} {...props} />}
	</AutoSizer>
);

export default AutoSizedVariableSizeList;
